import { useAuthenticator } from '@aws-amplify/ui-react';
import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GenericDbCall } from './LambdaApi.js';
import { useUserActions } from './ApiHelper.js';
import { useClient } from '../context/ClientContext.tsx'; // keep .tsx if context is typed

const logging = false;

const PostLoginRedirect = () => {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { saveUser } = useUserActions();
  const navigate = useNavigate();
  const hasRun = useRef(false);
  //const { setClientInfo } = useClient();

  useEffect(() => {
    if (user && !hasRun.current) {
      hasRun.current = true;

      const runLoginFlow = async () => {
        try {
          const getPayload = {
            table: 'users',
            operation: 'get',
            key: {
              UserId: { S: user.signInDetails.loginId },
            },
          };

          const userData = await GenericDbCall(getPayload);
          if (logging) console.log('User from DB:', userData);

          // if user active is false, block login
          if (userData?.IsActive?.BOOL === false) {
            if (logging) console.log('User is inactive, blocking login');

            // 1. Log the user out
            signOut();

            // 2. Redirect to your message page
            navigate('/loginRedirect?error=inactive', { replace: true });

            // 3. Stop rendering anything else
            return null;
          }

          //get or set defaults
          const userFirstLoginDtm = userData?.FirstLoginDatetime?.S || new Date().toISOString();
          const clientCode = userData?.ClientCode?.S || '';
          const isAdmin = userData?.IsAdmin?.BOOL || false;

          //if user DNE, create new user
          if (!userData || !userData.UserId) {
            if (logging) console.log('New user, will create record in DB');
            /*
            await saveUser(
              user.signInDetails.loginId,
              user.userId,
              clientCode,
              user.signInDetails.loginId.split('@')[0],
              user.signInDetails.loginId,
              userFirstLoginDtm,
              new Date().toISOString(),
              isAdmin,
              new Date(Date.now() + 30 * 24 * 60 * 60 * 1000), //expire in 30 days
              false,
              true
            );
            */

            await saveUser({
              userId: user.signInDetails.loginId,
              cognitoUserId: user.userId,
              clientCode: clientCode,
              username: user.signInDetails.loginId.split('@')[0],
              email: user.signInDetails.loginId,
              firstLoginDatetime: userFirstLoginDtm,
              lastLoginDatetime: new Date(),
              isAdmin: isAdmin,
              expirationDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
              subscriptionIsActive: false,
              userIsActive: true
            });


          }

          if (!clientCode) {
            if (logging) console.log('clientCode missing, redirecting');
            navigate('/select-client', {
              replace: true,
              state: { userFromDB: userData },
            });
            return;
          }



          //dont get this from the client, get it from subscription data
          //need to account for free trial period of 30 days if no subscription exists
          /*
          const clientPayload = {
            table: 'clients',
            operation: 'get',
            key: {
              ClientCode: { S: clientCode },
            },
          };
          const clientData = await GenericDbCall(clientPayload);
          const expirationDate = clientData?.ExpirationDatetime?.S
            ? new Date(clientData.ExpirationDatetime.S)
            : null;
          */

          //default to null - expiration set if no subscription is found.
          let expirationDate = null;

          const subscriptionsPayload = {
            table: 'subscriptions',
            operation: 'query',
            query: {
              ClientCode: { S: clientCode },
            },
          };
          const subscriptionsData = await GenericDbCall(subscriptionsPayload);
          if (logging) console.log('Subscriptions from DB:', subscriptionsData);

          const items = subscriptionsData.Items || [];
          const subscriptionIsActive = items.some(item => item.status?.S === "active");
          if (logging) console.log('subscriptionIsActive:', subscriptionIsActive);
          if (!subscriptionIsActive) {
            const clientPayload = {
              table: 'clients',
              operation: 'get',
              key: {
                ClientCode: { S: clientCode },
              },
            };
            const clientData = await GenericDbCall(clientPayload);
            const firstLoginDatetime = clientData?.FirstLoginDatetime?.S
              ? new Date(clientData.FirstLoginDatetime.S)
              : new Date(userFirstLoginDtm);
            let parsedExpiration = new Date(clientData?.ExpirationDatetime?.S);
            expirationDate = clientData?.ExpirationDatetime?.S && !isNaN(parsedExpiration)
              ? parsedExpiration
              : new Date(firstLoginDatetime.getTime() + 30 * 24 * 60 * 60 * 1000);
          }

          await saveUser({
            userId: user.signInDetails.loginId,
            cognitoUserId: user.userId,
            clientCode: clientCode,
            username: user.signInDetails.loginId.split('@')[0],
            email: user.signInDetails.loginId,
            firstLoginDatetime: userFirstLoginDtm,
            lastLoginDatetime: new Date(),
            isAdmin: isAdmin,
            expirationDate: expirationDate,
            subscriptionIsActive: subscriptionIsActive,
            userIsActive: true
          });

          /*
          const putPayload = {
            table: 'users',
            operation: 'put',
            item: {
              UserId: { S: user.signInDetails.loginId },
              CognitoUserId: { S: user.userId },
              ClientCode: { S: clientCode },
              Username: { S: user.signInDetails.loginId.split('@')[0] },
              Email: { S: user.signInDetails.loginId },
              FirstLoginDatetime: { S: userFirstLoginDtm },
              LastLoginDatetime: { S: new Date().toISOString() },
              IsActive: { BOOL: true },
              IsAdmin: { BOOL: isAdmin },
            },
          };

          await GenericDbCall(putPayload);

          setClientInfo({
            name: user.signInDetails.loginId,
            organization: clientCode,
            isAdmin,
            expirationDate,
            subscriptionIsActive,
          });
          */

          if (logging) console.log('Client ExpirationDatetime:', expirationDate);
          // Check if expired
          const now = new Date();
          if (!subscriptionIsActive &&
            expirationDate && expirationDate < now) {
            if (logging) console.log('License expired, redirecting to plan selection');
            navigate('/select-plan', { replace: true });
            return;
          }

          navigate('/', { replace: true });
        } catch (error) {
          console.error('Login flow error:', error);
        }
      };

      runLoginFlow();
    }
  }, [user, navigate]);

  return <p>Logging in...</p>;
};

export default PostLoginRedirect;